export const MAX_HIDDEN_FEED_EVENTS = 500;

export type FeedPreferences = { hiddenEventIds: string[] };

export const validFeedPreferenceId = (value: unknown): value is string =>
  typeof value === 'string' && /^[A-Za-z0-9_-]{1,128}$/.test(value);

/** Kişisel tercih belgesinden yalnız akış gizleme kimlikleri çıkar. */
export function feedPreferences(value: any): FeedPreferences {
  return {
    hiddenEventIds: Array.isArray(value?.hidden_event_ids)
      ? Array.from(new Set<string>(value.hidden_event_ids.filter(validFeedPreferenceId)))
      : [],
  };
}
